// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA4yJYuJtteo-T0ptmCl9kQZ-P4-TGFmjc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "temple-cms-management.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "temple-cms-management",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "temple-cms-management.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "728668793152",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:728668793152:web:1f9d947a9e03e4f68032a5",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-4HT8PSWJ44"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Initialize Firestore with memory-only cache (no persistent cache)
// This ensures data is always fresh from the server
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const storage = getStorage(app);

// Cloud Functions (used by admin dashboard push notifications)
export const functions = getFunctions(app);
export default app;
